import { render, staticRenderFns } from "./EdocGrid.vue?vue&type=template&id=850f97dc"
import script from "./EdocGrid.vue?vue&type=script&lang=js"
export * from "./EdocGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports